<template>
    <div>
        <div class="form-group">
            <label for="propertyLabel">{{$t('text.propertyEntry.name')}}</label>
            <input type="text" class="form-control mw-100" id="propertyLabel"
                   aria-describedby="propertyLabel"
                   name="propertyLabel"
                   v-model="property.name"
                   :disabled="editProperty"
            >
        </div>

        <div class="form-group">
            <label for="propertyDisplayLabel">{{$t('text.propertyEntry.displayLabel')}}</label>
            <input type="text" class="form-control mw-100" id="propertyDisplayLabel"
                   aria-describedby="propertyDisplayLabel"
                   name="propertyDisplayLabel"
                   v-model="property.displayLabel"
            >
        </div>

        <div class="form-group">
            <label for="propertyDescription">{{$t('text.propertyEntry.description')}}</label>
            <textarea class="form-control" id="propertyDescription" aria-describedby="propertyDescription"
                      name="propertyDescription"
                      v-model="property.description"
            ></textarea>
        </div>

        <div class="form-group">
            <label for="dataType">{{$t('text.propertyEntry.dataType')}}</label>
            <v-select
                    class="form-control"
                    id="dataType"
                    name="dataType"
                    :options="$t('text.propertyEntry.dataTypeOptions')"
                    v-model="property.dataType"
                    :disabled="editProperty"
            >
                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
            </v-select>
        </div>
        <div class="form-group">
            <label for="requirement">{{$t('text.propertyEntry.requirement')}}</label>
            <v-select
                    class="form-control"
                    id="requirement"
                    name="dataType"
                    :options="$t('text.propertyEntry.requirementOptions')"
                    v-model="property.requirement"
                    :disabled="editProperty"
            >
                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
            </v-select>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="property.multiple" :disabled="editProperty">
            <label class="form-check-label" for="defaultCheck1">
                Multiple
            </label>
        </div>
        <div class="form-group">
            <label for="defaultValue">{{$t('text.propertyEntry.defaultValue')}}</label>
            <input type="text" class="form-control mw-100" id="defaultValue"
                   aria-describedby="defaultValue"
                   name="defaultValue"
                   v-model="property.defaultValue"
            >
        </div>
        <div class="form-group">
            <label for="constraint">{{$t('text.propertyEntry.constraint')}}</label>
            <v-select
                    class="form-control"
                    id="constraint"
                    name="constraint"
                    :options="$t('text.propertyEntry.constraintOptions')"
                    v-model="property.constraint"
            >
                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
            </v-select>
        </div>
        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.regularExpression')">
            <label for="regularExpression">{{$t('text.propertyEntry.regularExpression')}}</label>
            <input type="text" class="form-control mw-100"
                   id="regularExpression"
                   name="regularExpression"
                   aria-describedby="regularExpression"
                    v-model="property.constraintProps.regularExpression"
            />
        </div>
        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.minMaxLength')">
            <label for="minlength">{{$t('text.propertyEntry.minimumLength')}}</label>
            <input type="text" class="form-control mw-100"
                   id="minlength"
                   name="minLength"
                   aria-describedby="minLength"
                   v-model="property.constraintProps.minimumLength"
            />
        </div>
        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.minMaxLength')">
            <label for="maxLength">{{$t('text.propertyEntry.maximumLength')}}</label>
            <input type="text" class="form-control mw-100"
                   id="maxLength"
                   name="maxLength"
                   aria-describedby="maxLength"
                   v-model="property.constraintProps.maximumLength"
            />
        </div>

        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.minMaxValue')">
            <label for="minValue">{{$t('text.propertyEntry.minimumValue')}}</label>
            <input type="text" class="form-control mw-100"
                   id="minValue"
                   name="minValue"
                   aria-describedby="minValue"
                   v-model="property.constraintProps.minimumValue"
            />
        </div>
        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.minMaxValue')">
            <label for="maxValue">{{$t('text.propertyEntry.maximumValue')}}</label>
            <input type="text" class="form-control mw-100"
                   id="maxValue"
                   name="maxValue"
                   aria-describedby="maxValue"
                   v-model="property.constraintProps.maximumValue"
            />
        </div>
        <div class="form-group" v-if="property.constraint === $t('text.propertyEntry.javaClass')">
            <label for="javaClass">{{$t('text.propertyEntry.javaClassName')}}</label>
            <input type="text" class="form-control mw-100"
                   id="javaClass"
                   name="javaClass"
                   aria-describedby="javaClass"
                   v-model="property.constraintProps.javaClass"
            />
        </div>
        <div class="form-group">
            <label for="indexed">{{$t('text.propertyEntry.indexed')}}</label>
            <v-select
                    class="form-control"
                    id="indexed"
                    name="indexed"
                    :options="indexedOptions"
                    v-model="property.indexed"
                    :disabled="editProperty"
            >
                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
            </v-select>
        </div>
    </div>
</template>

<script>

    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "PropertyEntry",
        components: {
            vSelect
        },


        props: {
          editProperty: {Boolean, defaultValue: false},
          propertyToEdit: Object
        },


        data() {
            return {
                property: {
                    name: null,
                    displayLabel: null,
                    description: null,
                    dataType: null,
                    requirement: null,
                    multiple: null,
                    defaultValue: null,
                    constraint: null,
                    indexed: null,
                    constraintProps: {
                        regularExpression: null,
                        minimumLength: null,
                        maximumLength: null,
                        minimumValue: null,
                        maximumValue: null,
                        listOfValues: null,
                        javaClass: null
                    },
                },

                constraintOptions: null,
                indexedOptions: null,
            }
        },


        watch: {
            "property.dataType": function() {
                console.log("changed");
                if(this.property.dataType == "d:text" || this.property.dataType == "d:mltext") {
                    this.indexedOptions = this.$t('text.propertyEntry.indexedOptionsText');

                }
                else if(this.property.dataType == "d:boolean") {
                    console.log("boolean");
                    this.indexedOptions = this.$t('text.propertyEntry.indexedOptionsBoolean');
                    this.property.indexed = this.$t('text.propertyEntry.constraintDefault');
                }
                else {
                    this.indexedOptions = this.$t('text.propertyEntry.indexedOptionsDefault');
                    this.property.indexed = this.$t('text.propertyEntry.basic');
                }
            }

        },

        mounted() {

            console.log("mounted", this.editProperty);
            this.property.dataType = this.$t('text.propertyEntry.dataTypeDefault');
            this.property.requirement = this.$t('text.propertyEntry.requirementDefault');
            this.property.constraint = this.$t('text.propertyEntry.constraintDefault');
            this.property.indexed = this.$t('text.propertyEntry.indexedDefault');
            this.property.name = null;
            this.property.displayLabel = null;
            this.property.defaultValue = null;
            this.constraintOptions = this.$t('text.propertyEntry.constraintOptions');

            if(this.editProperty !== true) {
                this.$root.$on("addNewProperty", () => {
                    console.log("add new property");
                    this.$root.$emit('pushPropertyToList', this.property);
                });

            }

            else {
                this.property = _.cloneDeep(this.propertyToEdit);
                if(this.property.constraintProps == null) {
                    this.property.constraintProps = {
                        regularExpression: null,
                        minimumLength: null,
                        maximumLength: null,
                        minimumValue: null,
                        maximumValue: null,
                        listOfValues: null,
                        javaClass: null
                    }
                }
                this.$root.$on("setEditProperty", (property) => {
                    this.property = property;
                });

                this.$root.$on("setEditedPropertyUpdated", () => {
                    console.log("setEditedPropertyUpdated");
                    this.$root.$emit("updateProperty", this.property)
                });
            }

            this.$root.$on("resetProperty", () => {
                console.log("reset property");
                this.property.dataType = this.$t('text.propertyEntry.dataTypeDefault');
                this.property.requirement = this.$t('text.propertyEntry.requirementDefault');
                this.property.constraint = this.$t('text.propertyEntry.constraintDefault');
                this.property.indexed = this.$t('text.propertyEntry.indexedDefault');
                this.property.name = null;
                this.property.displayLabel = null;
                this.property.defaultValue = null;
                this.property.description = null;
            });

        },
        beforeDestroy() {
            console.log("destroying PropertyEntry");
            this.$root.$off("addNewProperty");
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PropertyEntry.vue